import { AsyncPipe } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { Currency } from '../../../api/v1/models/currency';
import { ConfigRepository } from '../../repositories/config.repository';
import { PriceCurrencyPipe } from '../../pipes/priceCurrency/price-currency.pipe';

@Component({
  selector: 'app-price',
  templateUrl: './currency.component.html',
  imports: [
    AsyncPipe,
    PriceCurrencyPipe
  ]
})
export class CurrencyComponent {
  private configRepository = inject(ConfigRepository);

  @Input() price: number;

  currency$: Observable<Currency | null> = this.configRepository.currency$;
  locale$: Observable<string | undefined | null> = this.configRepository.locale$;
}
